import React from 'react'
import CollapsableCard from '../../../common/card/CollapsableCard'
import ReportingGroups from '../Organization/ReportingGroups'
import { useGroupDashboardContext } from '../GroupDashboardContext'

const MemberHome = ({
  teamData = [],
}) => {

  const { filtersData } = useGroupDashboardContext()
  
  return (
    <>
        {
          filtersData.home?.reporting_groups_visibility &&
          <CollapsableCard title={ filtersData.home?.reporting_groups_label }>
              <ReportingGroups teamData={ teamData } />
          </CollapsableCard>
        }
    </>
  )
}

export default MemberHome
